import { I18n } from '@calendly/i18n'
import { useDropdown } from '@calendly/ui/components/dropdown'
import { IconButton } from '@calendly/ui/components/icon-button'
import { CopyIcon, DeleteIcon, EditPencilIcon, SettingsMenuVerticalIcon, StarIcon } from '@calendly/ui/components/icons'
import { Group, Item } from '@calendly/ui/components/menu'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { setUser, useGetUserQuery } from 'common'
import { ViewportDropdownMenu } from 'components/core/viewport_dropdown_menu'
import { Layout } from 'components/layout'


import { DeleteSchedulePopup } from './delete_schedule_popup'
import { RenameSchedulePopup } from './rename_schedule_popup'
import {
  useCreateAvailabilityScheduleMutation,
  useGetAvailabilitySchedulesQuery,
  useSetDefaultAvailabilityScheduleMutation
} from '../../../api'
import { SCHEDULES_PATH } from '../../../constants'

const getNameDuplicate = (name) => {
  const suffix = ` (${I18n.t('publisher.labels.cloned_suffix')})`

  return name.substring(0, 255 - suffix.length) + suffix
}

export const Settings = ({ selectedScheduleId }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [toggleDropdown, Dropdown, isExpanded] = useDropdown()

  const { data: { primary_availability_rule_id: defaultScheduleId } } = useGetUserQuery()
  const { data: allSchedules } = useGetAvailabilitySchedulesQuery()

  const [createAvailabilitySchedule] = useCreateAvailabilityScheduleMutation()
  const [setDefaultAvailabilitySchedule] = useSetDefaultAvailabilityScheduleMutation()

  const isRenameSchedulePopupOpen = history.location.search.includes('rename=true')
  const isDeleteSchedulePopupOpen = history.location.search.includes('delete=true')

  const selectedSchedule = allSchedules.find(({ id: scheduleId }) => scheduleId === selectedScheduleId)

  const handleDuplicate = () => createAvailabilitySchedule({
    name: getNameDuplicate(selectedSchedule.name),
    rules: selectedSchedule.rules,
    timezone: selectedSchedule.timezone,
    onSuccess: ({ id: newScheduleId }) => history.push(`${SCHEDULES_PATH}/${newScheduleId}`)
  })

  const handleSetAsDefault = () => {
    if (defaultScheduleId === selectedScheduleId) return

    setDefaultAvailabilitySchedule({
      id: selectedScheduleId,
      onSuccess: () => {
        dispatch(setUser({ primary_availability_rule_id: selectedScheduleId }))

        history.push(SCHEDULES_PATH)
      }
    })
  }

  return (
    <Layout relative>
      <IconButton
        aria-expanded={isExpanded}
        onClick={toggleDropdown}
        title={I18n.t('publisher.availability.schedules.settings', { name: selectedSchedule.name })}
      >
        <SettingsMenuVerticalIcon />
      </IconButton>
      <Dropdown>
        <ViewportDropdownMenu>
          <Group>
            <Item onClick={() => history.push(`${history.location.pathname}?rename=true`)}>
              <EditPencilIcon />
              {I18n.t('publisher.availability.schedules.settings_menu.rename')}
            </Item>
            {defaultScheduleId !== selectedScheduleId && (
              <Item onClick={handleSetAsDefault}>
                <StarIcon />
                {I18n.t('publisher.availability.schedules.settings_menu.default')}
              </Item>
            )}
            <Item onClick={handleDuplicate}>
              <CopyIcon />
              {I18n.t('publisher.availability.schedules.settings_menu.duplicate')}
            </Item>
          </Group>
          {allSchedules.length > 1 && (
            <Group>
              <Item onClick={() => history.push(`${history.location.pathname}?delete=true`)}>
                <DeleteIcon />
                {I18n.t('publisher.availability.schedules.settings_menu.delete')}
              </Item>
            </Group>
          )}
        </ViewportDropdownMenu>
      </Dropdown>
      {isRenameSchedulePopupOpen && (
        <RenameSchedulePopup selectedScheduleId={selectedScheduleId} />
      )}
      {isDeleteSchedulePopupOpen && (
        <DeleteSchedulePopup selectedScheduleId={selectedScheduleId} />
      )}
    </Layout>
  )
}
